// Unit Studying Data
// Structured for Supabase migration with multi-language support

export const unitStudyingData = {
  // User Learning Path Overview
  userLearningPath: {
    id: "joel_learning_path",
    userId: "joel",
    title: {
      tc: "Joel 的學習路徑",
      sc: "Joel 的学习路径",
      en: "Joel's Learning Path"
    },
    subtitle: {
      tc: "12 個單元 • CEFR A1",
      sc: "12 个单元 • CEFR A1",
      en: "12 Units • CEFR A1"
    },
    avatar: "📚",
    avatarDescription: {
      tc: "藍色戴眼鏡的生物正在讀書",
      sc: "蓝色戴眼镜的生物正在读书",
      en: "Blue creature with glasses reading a book"
    }
  },

  // Current Unit Information
  currentUnit: {
    id: "unit_1",
    unitNumber: 1,
    title: {
      tc: "打包行李",
      sc: "打包行李",
      en: "Packing Luggage"
    },
    description: {
      tc: "談綸汽車零件時使用過去進行時",
      sc: "谈论汽车零件时使用过去进行时",
      en: "Using the past continuous tense when discussing car parts"
    },
    progress: {
      completedLessons: 1,
      totalLessons: 64,
      percentage: 1.56
    }
  },

  // Lessons in Current Unit
  lessons: [
    {
      id: "lesson_1",
      lessonNumber: 1,
      title: {
        tc: "打包行李",
        sc: "打包行李",
        en: "Packing Luggage"
      },
      description: {
        tc: "談綸汽車零件時使用過去進行時",
        sc: "谈论汽车零件时使用过去进行时",
        en: "Using the past continuous tense when discussing car parts"
      },
      status: "active", // active, completed, locked
      statusColor: "green",
      isUnlocked: true,
      progress: 12.5, // 1/8 = 12.5%
      duration: {
        tc: "1 週",
        sc: "1 周",
        en: "1 week"
      },
      difficulty: "beginner"
    },
    {
      id: "lesson_2",
      lessonNumber: 2,
      title: {
        tc: "機場安檢",
        sc: "机场安检",
        en: "Airport Security Check"
      },
      description: {
        tc: "學習機場安檢相關詞彙和表達",
        sc: "学习机场安检相关词汇和表达",
        en: "Learning vocabulary and expressions related to airport security check"
      },
      status: "locked",
      statusColor: "gray",
      isUnlocked: false,
      progress: 0,
      duration: {
        tc: "1 週",
        sc: "1 周",
        en: "1 week"
      },
      difficulty: "beginner"
    },
    {
      id: "lesson_3",
      lessonNumber: 3,
      title: {
        tc: "飛機上",
        sc: "飞机上",
        en: "On the Plane"
      },
      description: {
        tc: "學習飛機上使用的詞彙和短語",
        sc: "学习飞机上使用的词汇和短语",
        en: "Learning vocabulary and phrases used on the plane"
      },
      status: "locked",
      statusColor: "gray",
      isUnlocked: false,
      progress: 0,
      duration: {
        tc: "1 週",
        sc: "1 周",
        en: "1 week"
      },
      difficulty: "beginner"
    },
    {
      id: "lesson_4",
      lessonNumber: 4,
      title: {
        tc: "抵達目的地",
        sc: "抵达目的地",
        en: "Arriving at Destination"
      },
      description: {
        tc: "學習抵達目的地時的對話和表達",
        sc: "学习抵达目的地时的对话和表达",
        en: "Learning conversations and expressions when arriving at destination"
      },
      status: "locked",
      statusColor: "gray",
      isUnlocked: false,
      progress: 0,
      duration: {
        tc: "1 週",
        sc: "1 周",
        en: "1 week"
      },
      difficulty: "beginner"
    },
    {
      id: "lesson_5",
      lessonNumber: 5,
      title: {
        tc: "酒店入住",
        sc: "酒店入住",
        en: "Hotel Check-in"
      },
      description: {
        tc: "學習酒店入住相關的詞彙和對話",
        sc: "学习酒店入住相关的词汇和对话",
        en: "Learning vocabulary and conversations related to hotel check-in"
      },
      status: "locked",
      statusColor: "gray",
      isUnlocked: false,
      progress: 0,
      duration: {
        tc: "1 週",
        sc: "1 周",
        en: "1 week"
      },
      difficulty: "beginner"
    },
    {
      id: "lesson_6",
      lessonNumber: 6,
      title: {
        tc: "餐廳用餐",
        sc: "餐厅用餐",
        en: "Dining at a Restaurant"
      },
      description: {
        tc: "學習餐廳用餐時的詞彙和表達",
        sc: "学习餐厅用餐时的词汇和表达",
        en: "Learning vocabulary and expressions when dining at a restaurant"
      },
      status: "locked",
      statusColor: "gray",
      isUnlocked: false,
      progress: 0,
      duration: {
        tc: "1 週",
        sc: "1 周",
        en: "1 week"
      },
      difficulty: "beginner"
    },
    {
      id: "lesson_7",
      lessonNumber: 7,
      title: {
        tc: "購物",
        sc: "购物",
        en: "Shopping"
      },
      description: {
        tc: "學習購物相關的詞彙和對話",
        sc: "学习购物相关的词汇和对话",
        en: "Learning vocabulary and conversations related to shopping"
      },
      status: "locked",
      statusColor: "gray",
      isUnlocked: false,
      progress: 0,
      duration: {
        tc: "1 週",
        sc: "1 周",
        en: "1 week"
      },
      difficulty: "beginner"
    },
    {
      id: "lesson_8",
      lessonNumber: 8,
      title: {
        tc: "緊急情況",
        sc: "紧急情况",
        en: "Emergency Situation"
      },
      description: {
        tc: "學習緊急情況下的詞彙和表達",
        sc: "学习紧急情况下的词汇和表达",
        en: "Learning vocabulary and expressions in emergency situations"
      },
      status: "locked",
      statusColor: "gray",
      isUnlocked: false,
      progress: 0,
      duration: {
        tc: "1 週",
        sc: "1 周",
        en: "1 week"
      },
      difficulty: "beginner"
    }
  ],

  // Navigation and UI Elements
  navigation: {
    backButton: {
      tc: "返回",
      sc: "返回",
      en: "Back"
    },
    startLessonButton: {
      tc: "開始課程",
      sc: "开始课程",
      en: "Start Lesson"
    },
    continueButton: {
      tc: "繼續",
      sc: "继续",
      en: "Continue"
    }
  },

  // Progress Indicators
  progressIndicators: {
    lessonProgress: {
      tc: "課程進度",
      sc: "课程进度",
      en: "Lesson Progress"
    },
    unitProgress: {
      tc: "單元進度",
      sc: "单元进度",
      en: "Unit Progress"
    },
    overallProgress: {
      tc: "整體進度",
      sc: "整体进度",
      en: "Overall Progress"
    }
  },

  // Status Messages
  statusMessages: {
    lessonCompleted: {
      tc: "課程完成",
      sc: "课程完成",
      en: "Lesson Completed"
    },
    lessonInProgress: {
      tc: "課程進行中",
      sc: "课程进行中",
      en: "Lesson in Progress"
    },
    lessonLocked: {
      tc: "課程已鎖定",
      sc: "课程已锁定",
      en: "Lesson Locked"
    },
    lessonAvailable: {
      tc: "課程可用",
      sc: "课程可用",
      en: "Lesson Available"
    }
  }
};

// Helper functions for unit studying management
export const getUnitById = (unitId) => {
  // This would typically fetch from database
  // For now, return the current unit data
  return unitStudyingData.currentUnit;
};

export const getLessonsByUnitId = (unitId) => {
  // This would typically fetch from database
  // For now, return the lessons array
  return unitStudyingData.lessons;
};

export const getLessonById = (lessonId) => {
  return unitStudyingData.lessons.find(lesson => lesson.id === lessonId);
};

export const updateLessonProgress = (lessonId, status) => {
  // This would typically update the database
  // For now, just log the update
  console.log(`Updating lesson ${lessonId} to status: ${status}`);
};

export const getUnitProgress = (unitId) => {
  const lessons = getLessonsByUnitId(unitId);
  const completedLessons = lessons.filter(lesson => lesson.status === 'completed').length;
  const totalLessons = lessons.length;
  
  return {
    completed: completedLessons,
    total: totalLessons,
    percentage: Math.round((completedLessons / totalLessons) * 100)
  };
};
